import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useStore } from "src/stores";
import { useGetUser } from "./queries";
import {
  flattenAgentThreads,
  getAgentThreadOptions,
  getAgentThreadsOptions,
} from "./queries/agent-threads";

export const useAgentThreads = () => {
  const { agentStore } = useStore();
  const { orgId = "" } = useParams();
  const { data: user } = useGetUser();
  const query = useInfiniteQuery(
    getAgentThreadsOptions(agentStore.client, orgId, user?.id ?? "")
  );
  return { ...query, threads: flattenAgentThreads(query.data?.pages) };
};

export const useCurrentAgentThread = () => {
  const { agentStore } = useStore();
  const { orgId = "" } = useParams();
  return useQuery(
    getAgentThreadOptions(agentStore.client, orgId, agentStore.currentThreadId)
  );
};
